import React, { FC } from 'react';
import { Link } from 'react-router-dom';
import { SettingsItemType } from 'pages/settings/types';

const SettingsBox: FC<SettingsItemType> = ({ icon, title, description, comingSoon, route }) => {
  return !comingSoon && route ? (
    <Link to={route}>
      <div className='w-full h-[227px] bg-transparent rounded-md border border-[#F2F2F3] pt-[36px] px-[24px] hover:bg-gray-light cursor-pointer'>
        <div className='flex justify-between text-[#F73B58]'>{icon}</div>
        <h6 className='text-gray-6 text-xl font-semibold mt-10'>{title}</h6>
        <p className='text-gray-8 text-sm font-md mt-2'>{description}</p>
      </div>
    </Link>
  ) : (
    <div
      className={`w-full h-[227px] rounded-md border border-[#F2F2F3] pt-[36px] px-[24px] ${
        comingSoon ? 'bg-gray-light' : 'bg-transparent hover:bg-gray-light cursor-pointer'
      } `}>
      <div className='flex justify-between'>
        <span className='text-[#F73B58]'>{icon}</span>
        {comingSoon && (
          <div className='bg-[#FDD3D9] px-[6px] h-[22px] py-[2px] rounded'>
            <p className='text-[#AC394A] text-xs'>Coming soon</p>
          </div>
        )}
      </div>
      <h6 className='text-gray-6 text-xl font-semibold mt-10'>{title}</h6>
      <p className='text-gray-8 text-sm font-md mt-2'>{description}</p>
    </div>
  );
};

export default SettingsBox;
